import { buildModelManager } from "../builder.js";
const DefaultAccountingAuditLogSelection = {
  __typename: true,
  id: true,
  attemptNumber: true,
  connectionId: true,
  createdAt: true,
  direction: true,
  entityId: true,
  entityType: true,
  externalId: true,
  operation: true,
  payloadBefore: true,
  payloadSent: true,
  responseBody: true,
  responseStatus: true,
  rollbackReason: true,
  rolledBack: true,
  succeeded: true,
  updatedAt: true
};
const modelApiIdentifier = "accountingAuditLog";
const pluralModelApiIdentifier = "accountingAuditLogs";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAccountingAuditLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAccountingAuditLogSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAccountingAuditLogSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAccountingAuditLogSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAccountingAuditLogSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAccountingAuditLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAccountingAuditLogSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "accountingAuditLogGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AccountingAuditLogManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAccountingAuditLogSelection,
  operations
);
export {
  AccountingAuditLogManager,
  DefaultAccountingAuditLogSelection
};
//# sourceMappingURL=AccountingAuditLog.js.map
